import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import moment from 'moment';
import {reactTableText} from '../../../../constants/configs';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import ReactTable from 'react-table';
import Api from '../../../../services/Api';
import {i18nizeDate, getStatusColor, mask} from '../../../../helpers/Utils';
import BankAccountDetails from '../../../../containers/BankAccountDetails';
import {keyBy, mapValues, omit} from 'lodash';
import ReactTableSelectFilter from '../../../../components/ReactTableSelectFilter';
import ReactTableDateFilter from '../../../../components/ReactTableDateFilter';
import ReactTableTextFilter from '../../../../components/ReactTableTextFilter';
import {NotificationManager} from '../../../../components/common/react-notifications';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bankAccounts: [],
      pages: -1,
      loading: false,
      refreshing: false,
      selectedStartDate: null,
      selectedEndDate: null,
      expanded: {},
    };
    this.renderInquiryStatusFilter = this.renderInquiryStatusFilter.bind(this);
    this.renderStatusFilter = this.renderStatusFilter.bind(this);
    this.renderDateFilter = this.renderDateFilter.bind(this);
  }

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/user-bank-account/full-view/card-number',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
            ...(this.state.selectedStartDate ? {from: moment(this.state.selectedStartDate).toISOString()} : null),
            ...(this.state.selectedEndDate ? {to: moment(this.state.selectedEndDate).toISOString()} : null),
          }
        });
      this.setState({
        bankAccounts: data.rows,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  getColumns = t => [
    {
      Header: t('First Name'),
      accessor: 'firstName',
      filterable: true,
      Filter: ReactTableTextFilter,
      Cell: props => <span>
        {props.original.legalFirstName ?
          `${props.original.legalFirstName} (${t('legal')})` :
          `${props.value} (${t('profile')})`
        }
      </span>
    },
    {
      Header: t('Last Name'),
      accessor: 'lastName',
      Filter: ReactTableTextFilter,
      Cell: props => <span>
        {props.original.legalLastName ?
          `${props.original.legalLastName} (${t('legal')})` :
          `${props.value} (${t('profile')})`
        }
      </span>,
      filterable: true,
    },
    {
      Header: t('Card Number'),
      accessor: 'cardNumber',
      filterable: true,
      Filter: ReactTableTextFilter,
      Cell: props => <span>{mask(props.value, '####-####-####-####')}</span>,
    },
    {
      Header: t('Inquiry Status'),
      accessor: 'status',
      filterable: true,
      Filter: this.renderInquiryStatusFilter,
      Cell: props => <span className={getStatusColor(props.value)}>{t(props.value)}</span>,
    },
    {
      Header: t('Status'),
      accessor: 'deleted',
      filterable: true,
      width: 120,
      Filter: this.renderStatusFilter,
      Cell: props => {
        return (
          <span className={!props.original.deletedAt ? getStatusColor("Registered") : getStatusColor("Deleted")}>
            {!props.original.deletedAt ? t("Registered") : t("Deleted")}
          </span>
        );
      },
    },
    {
      Header: t('Register Date'),
      accessor: 'createdAt',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      filterable: true,
      Filter: this.renderDateFilter,
    },
    {
      Header: t('Update Date'),
      accessor: 'updatedAt',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
    },
    {
      Header: t('View'),
      width: 60,
      Cell: props => <Link to={{
        pathname: '/dashboard/users/' + props.original.userId,
        state: {
          section: 'Bank Accounts',
          cardNumber: props.original.cardNumber,
        },
      }}
      > <i className="simple-icon-eye view-icon"/> </Link>,
    },
  ];

  renderStatusFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: false, label: t('Registered')},
      {value: true, label: t('Deleted')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderInquiryStatusFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'Pending', label: t('Pending')},
      {value: 'Rejected', label: t('Rejected')},
      {value: 'Verified', label: t('Verified')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderDateFilter({onChange}) {
    const {selectedStartDate, selectedEndDate} = this.state;
    return <ReactTableDateFilter
      onChange={onChange}
      handleDateChange={this.handleDateChange}
      selectedStartDate={selectedStartDate}
      selectedEndDate={selectedEndDate}
    />;
  }

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    });
  };

  updateList = (values, index) => {
    const {bankAccounts} = this.state;
    let list = [...bankAccounts];
    list.splice(index, 1, {...bankAccounts[index], ...values});
    this.setState({bankAccounts: list});
  };

  refreshList = async () => {
    const {t} = this.props;
    this.setState({refreshing: true});
    await this.fetchData(this.table.state);
    this.setState({refreshing: false});
    NotificationManager.info(t('Card numbers list updated successfully'), t('Message'));
  };

  render() {
    const {t, match} = this.props;
    const {bankAccounts, pages, loading, refreshing, expanded} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="d-flex flex-row justify-content-end align-items-center">
                  <Button
                    outline
                    disabled={refreshing || loading}
                    className="d-flex align-items-center justify-content-center"
                    onClick={this.refreshList}>
                    <i className='icon-File-Refresh text-large'/>
                    <span className="mx-1">{t('Refresh')}</span>
                  </Button>
                </CardTitle>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  data={bankAccounts}
                  pages={pages}
                  loading={loading}
                  sortable={false}
                  resizable={true}
                  expanded={expanded}
                  onPageChange={() => {this.setState({expanded: {}});}}
                  onExpandedChange={this.onExpanded}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  defaultPageSize={25}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                  SubComponent={row =>
                    <BankAccountDetails
                      itemIndex={row.index}
                      bankAccount={row.original}
                      updateList={this.updateList}
                    />
                  }
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
